export default __webpack_public_path__ + "static/media/body_3_male.f123ca67.png";